import RewardsSearch from './RewardsSearch';

export default RewardsSearch;
